<template>
    <modal
    name="efileLcaPopupModal"
    classes="v-modal-sec"
    :min-width="200"
    :min-height="200"
    :scrollable="true"
    :reset="true"
    width="600px"
    height="auto"
  >
    <div class="v-modal profile_details_modal">
      <div class="popup-header fromDetailsPage">
        <h2 class="popup-title">E-File LCA</h2>
        <span  @click="hideMe()">
          <em class="material-icons">close</em>
        </span>
      </div>

      <form @submit.prevent data-vv-scope="efileLcaForm">
        <div class="form-container">
          <div class="vx-row">
            <div class="vx-col w-full">
            <div class="form_group">
              <label for class="form_label">Choose Attorney<em>*</em></label>             
              <div class="con-select w-full select-large">
                <multiselect
                  name="users"
                  v-model="selectedUser"
                  :close-on-select="true"
                  v-validate="'required'"
                  :multiple="false"
                  :show-labels="false"
                  label="name"
                  data-vv-as="Attorney"
                  placeholder="Select Attorney"
                  :options="attroneyList"
                  :searchable="true"
                  :allow-empty="false"
                >
                  <template slot="selection" slot-scope="{ values, isOpen }">
                    <span
                      class="multiselect__selectcustom"
                      v-if="values.length && !isOpen"
                      >{{ values.length }} selected</span
                    >
                    <span
                      class="multiselect__selectcustom"
                      v-if="values.length && isOpen"
                    ></span>
                  </template>
                </multiselect>
              </div>

              <span
                class="text-danger text-sm"
                v-show="errors.has('efileLcaForm.users')"
                >{{ errors.first("efileLcaForm.users") }}</span
              >
            </div>
          </div>

          </div>
          <div v-show="formErrors">
            <vs-alert
              color="warning"
              class="warning-alert reg-warning-alert no-border-radius"
              icon-pack="IntakePortal"
              icon="IP-information-button"
              active="true"
              >{{ formErrors }}</vs-alert
            >
          </div>
        </div>
        <div class="popup-footer relative">
          <span class="loader" v-if="loading"><img src="@/assets/images/main/loader.gif"/></span>

          <vs-button color="dark" @click="hideMe()" class="cancel"
            type="filled">Cancel</vs-button>
          <vs-button color="success"
            :disabled="loading" @click="submitForm()"
            class="save"
            type="filled">
            <template v-if="checkProperty(petitionDetails, 'lcaDetails') && checkProperty(petitionDetails, 'lcaDetails', 'efileAttorneyId')">Update</template>
            <template v-else>Submit</template>
            
          </vs-button>
        </div>        
      </form>
    </div>
  </modal>
</template>
<script>
export default {
    components: {

    },
    methods: {
        submitForm(){
            this.$validator.validateAll("efileLcaForm").then((result) => {
                if(result){
                    let postData ={
                        "lcaId":'',
                        "attorneyId": this.checkProperty(this.selectedUser, '_id')
                    };
                    if(this.callFromLca){
                        postData['lcaId'] = this.checkProperty(this.petitionDetails, '_id')
                    }else{
                        postData['lcaId'] = this.checkProperty(this.petitionDetails, 'lcaId')
                    }
                    let url = '/lca/update-efile-attorney';
                    this.loading = true;
                    this.$store.dispatch("commonAction" ,{data:postData,path:url}).then((res)=>{
                        this.loading = false;
                        this.$emit('openLcaEfileApp', true)
                    }).catch((err)=>{
                        this.formErrors = err;
                        this.loading = false;
                    })
                }
            })
        },
        hideMe(){
            this.$modal.hide('efileLcaPopupModal');
            this.$emit("hideMe");
        },
    },
    watch: {

    },
    mounted() {
        if(this.callFromLca){
            if(this.checkProperty(this.petitionDetails, 'efileAttorneyId')){ 
                if(this.checkProperty(this.attroneyList, 'length')>0){
                    let findObj = _.find(this.attroneyList, {'_id':this.petitionDetails['efileAttorneyId']});
                    if(findObj){
                        this.selectedUser = findObj;
                    }
                }
            }
        }else{
            if(this.checkProperty(this.petitionDetails, 'lcaDetails') && this.checkProperty(this.petitionDetails, 'lcaDetails', 'efileAttorneyId')){ 
                if(this.checkProperty(this.attroneyList, 'length')>0){
                    let findObj = _.find(this.attroneyList, {'_id':this.petitionDetails['lcaDetails']['efileAttorneyId']});
                    if(findObj){
                        this.selectedUser = findObj;
                    }
                }
            }
        }
        
        this.$modal.show('efileLcaPopupModal');
    },
    data: () => ({
        selectedUser:null,
        formErrors:'',
        loading:false,

    }),
    props: {
        callFromLca:{
            type: Boolean,
            default: false,
        },
        petitionDetails: {
            type: Object,
            default: null,
        },
        attroneyList:{
            type: Array,
            default: [],
        }
    }

}

</script>